export enum MimeType {
	JPEG = 'image/jpeg',
	PNG = 'image/png'
}
